import { jsx as e } from "react/jsx-runtime";

import o from "../../hooks/useTableContext/index.js";

import { useMemo as r } from "react";

import t from "../Row/index.js";

import l from "../Cell/index.js";

import n from "../SkeletonCell/index.js";

const i = ({length: i}) => {
    const {model: s} = o();
    if ("production" !== process.env.NODE_ENV && !s) throw new Error('DummyRows component is only supported within tables using "useTable". To render a static loading cells, use <Table.SkeletonCell />');
    const m = s?.getVisibleFlatColumns(), a = r((() => Array.from({
        length: i || 25
    }, ((e, o) => o))), [ i ]), d = r((() => Array.from({
        length: m?.length || 0
    }, ((e, o) => o))), [ m ]);
    return a.map((o => e(t, {
        id: `loading:row:${o}`,
        children: d.map((o => e(l, {
            children: e(n, {})
        }, `loading:cell:${o}`)))
    }, `loading:row:${o}`)));
};

export { i as default };
//# sourceMappingURL=index.js.map
